import { cyrb53 } from '@paradigm/utils/src/hash';
import * as colors from '@paradigm/design-system/src/colors';

const COLORS: readonly string[] = [
  colors.midnightBlue,
  colors.seaGreen,
  colors.fountainBlue,
  colors.maroonFlush,
  colors.studio,
  colors.fireBush,
  colors.mauve,
  colors.frenchRose,
];

export function counterpartyColor(deskName: string): string {
  const hash = cyrb53(deskName);
  return COLORS[Math.abs(hash) % COLORS.length]!;
}
